<template>
  <div class="mfooter">
    <div class="mfooter-inner">
      <div class="mfooter-inner-tit">
        <div class="title" @click="contactUs = true">Contact Us</div>
        <div class="title" @click="goPath('/privacypolicy')">Privacy Policy</div>
        <div class="title" @click="goPath('/termsofuse')">Terms of Use</div>
      </div>
      <div class="mfooter-inner-info">
        <div class="more">
          <img src="../../assets/images/component/thinkgrow_homepage_footer_logo_03.png" alt="">
          <span class="info">© {{year()}} ThinkGrow All Rights reserved | Powered by TrolMaster</span>
        </div>
      </div>
    </div>
    <!-- Contact Us -->
    <el-dialog title="Contact Us" :visible.sync="contactUs" width="7rem">
      <el-form :model="form">
        <el-form-item label="Address :">315 E. Enterprise Drive, Pueblo West, CO 81007
        </el-form-item>
        <el-form-item label="Tech Support :">877-420-9876
        </el-form-item>
        <el-form-item label="Email :">Support@thinkgrow.com
        </el-form-item>
        <el-form-item label="Powered by TrolMaster">
        </el-form-item>
      </el-form>
      <el-form :model="form1" style="margin-top: 40px">
        <el-form-item><span style="font-size: 0.36rem;line-height: 0.24rem;color: #303133;">Orders and Shipping:</span></el-form-item>
        <el-form-item label="ThinkGrow Agricultural Technology, Inc."></el-form-item>
        <el-form-item label="Phone :">279-300-4980</el-form-item>
        <el-form-item label="Email :">sales@thinkgrow.com</el-form-item>
        <el-form-item label="">7991 Folsom Blvd. Unit 2–3 Sacramento, CA 95826</el-form-item>
      </el-form>
    </el-dialog>
    <!-- Privacy Policy -->
    <el-dialog title="Privacy Policy" class="privacy" :visible.sync="privacy" width="6.5rem">
      <div class="privacy">
        <div class="title">
          Last updated: 20/02/2021</div>
        <br>
        <span class="fontbr">
          This privacy notice discloses the privacy practices for TrolMaster Agro Instruments Co., Ltd. This notice
          applies
          solely to information collected via our website, social media pages, applications, and trade show events
          (collectively, “services”). It will notify you of the following:
          <br><br>
          What information is collected from you, how it is used and with whom it may be shared.
          What choices are available to you regarding the use of your data.
          How you can correct any inaccuracies in the information.
          INFORMATION COLLECTION, USE, AND SHARING
          We are the sole owners of the information collected by our company channels. We only have access to/collect
          information that you voluntarily give us via email, phone calls, social channels, website forms, or other
          direct contact from you. We will not sell or rent this information to anyone. We will use your information to
          respond to you, regarding the reason you contacted us, and for marketing initiatives such as newsletters and
          follow-ups. We will not share your information with any third party outside of our organization, other than as
          necessary to complete business operations/fulfill your request, e.g. to ship an order. Unless you ask us not
          to, we may contact you via email in the future to tell you about specials, new products or services, or
          changes
          to this privacy policy.
          <br><br>
          YOUR ACCESS TO AND CONTROL OVER INFORMATION
          You may opt-out of any future contact from us at any time. You can do the following at any time by contacting
          us via the email address or phone number given on our website:
          <br><br>
          Request a copy of personal information as recorded and stored, if any.
          Change/correct any data we have about you.
          Update or otherwise correct inaccurate data in that record;
          Request that your personal information be permanently deleted; or
          Request to be removed from any sales or marketing communications.
          PROTECTION OF CHILDREN’S PERSONAL INFORMATION
          Our services are intended for business use only. We do not knowingly collect or solicit personal data from
          anyone under the age of 18. If you are under 18, please do not attempt to register for the site or send any
          personal data about yourself to us. If we learn that we have collected personal data from a child under age
          18,
          we will delete that information as quickly as possible. If you believe that a child under 18 may have provided
          us personal data, please contact us at Support@thinkgrowled.com
        </span>
      </div>
    </el-dialog>
    <!-- Terms of Use -->
    <el-dialog title="Terms of Use" :visible.sync="Terms" width="6.5rem">
      <div class="privacy">
        <div class="title"> Think Grow Led Terms of Use<br>
          Legal Information & Notices</div>
        <br>
        <span class="fontbr">
          Ownership of Site; Agreement to Terms of Use
          These Terms and Conditions of Use (the "Terms of Use") apply to the ThinkGrow Led website located at
          www.thinkgrowled.com, and all associated sites linked to www.thinkgrowled.com by TrolMaster Agro Instruments
          Co., Ltd, The Site is the property of TrolMaster Agro Instruments Co., Ltd. ("Trolmaster") and its licensors.
          BY
          USING THE SITE, YOU AGREE TO THESE TERMS OF USE; IF YOU DO NOT AGREE, DO NOT USE THE SITE.
          <br><br>
          Trolmaster reserves the right, at its sole discretion, to change, modify, add or remove portions of these
          Terms
          of Use, at any time. It is your responsibility to check these Terms of Use periodically for changes. Your
          continued use of the Site following the posting of changes will mean that you accept and agree to the changes.
          As long as you comply with these Terms of Use, Trolmaster grants you a personal, non-exclusive,
          non-transferable, limited privilege to enter and use the Site.
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'pcmain',
    data() {
      return {
        contactUs: false,
        privacy: false,
        Terms: false,
        form: {},
        form1: {}
      }
    },
    created() {},
    mounted() {},
    methods: {
      year() {
        let date = new Date();
        return date.getFullYear();
      },
      goPath(path) {
        this.$emit('show')
        this.$router.push({
          path: path
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mfooter {
    width: 100%;
    height: 2rem;

    .fontbr {
      /* 这两个在技术上是一样的, 为了兼容了浏览器两个都加上 */
      overflow-wrap: break-word;
      word-wrap: break-word;

      -ms-word-break: break-all;
      /* 这个的使用在web-kit中有些危险，他可能会阶段所有东西 */
      word-break: break-all;
      /* Instead use this non-standard one: */
      word-break: break-word;

      /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
      -ms-hyphens: auto;
      -moz-hyphens: auto;
      -webkit-hyphens: auto;
      hyphens: auto;
    }

    &-inner {
      padding: 0.4rem 0.2rem .3rem;

      &-tit {
        width: 5rem;
        margin: auto;
        text-align: center;
        color: #434343;
        display: flex;

        .title {
          flex: 1;
          font-size: 0.2rem;
          border-right: 1px #434040 solid;

          &:last-child {
            border: 0;
          }
        }
      }

      &-info {
        padding: .6rem 0.3rem .2rem;
        border-bottom: 1px #000000 solid;

        .more {
          .info {
            display: inline-block;
            vertical-align: middle;
            font-size: 0.18rem;
          }

          img {
            width: .74rem;
            display: inline-block;
            vertical-align: middle;
            margin-right: 0.2rem;
          }
        }
      }
    }

    .el-dialog__wrapper.privacy {
      top: -1rem;
    }

    .el-dialog__wrapper {

      >>>.el-dialog__headerbtn {
        font-size: 0.32rem;
        color: #5f5f5f;

        .el-dialog__close:hover {
          color: #313131;
        }
      }

      >>>.el-form-item__content {
        line-height: 0.45rem;
      }

      >>>.el-dialog__header {
        padding: 0.8rem 0.6rem 0;
      }

      >>>.el-dialog__body {
        padding: 0.4rem 0.6rem 0.6rem;
      }

      >>>.el-dialog__title {
        font-size: 0.36rem;
      }

      >>>.el-form-item {
        margin-bottom: 0;
        font-size: 0.2rem;
      }

      >>>.el-form-item__label {
        font-size: 0.3rem;
        line-height: 0.45rem;
      }

      >>>.el-form-item__content {
        font-size: 0.2rem;
      }

      .dialog-footer {
        padding-bottom: 0.4rem;
        text-align: right;

        .disbtn {
          margin-top: 0.25rem;
          display: inline-block;
          border: 0.02rem #313131 solid;
          color: #313131;
          border-radius: 0.03rem;
          font-size: 0.2rem;
          font-weight: 600;
          width: 1.6rem;
          height: 0.4rem;
          text-align: center;
          line-height: 0.4rem;
          cursor: pointer;

          &:hover {
            background-color: #313131;
            color: #fff;
          }
        }
      }

      .privacy {
        font-size: 0.16rem;
        line-height: 0.28rem;
        color: #313131;

        .title {
          font-size: 0.26rem;
          line-height: 0.32rem;
          font-weight: 600;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mlayout/component/Footerbar.vue